import sbiLogo from "assets/images/sbiLogo.png";
import aubLogo from "assets/images/AUB_Logo.png";
import { AppRoutes } from "types";

export const handleLogo = (logo:string) => {
    switch (logo) {
        case "SBI_LOGO":
          return sbiLogo
        case "AUB_LOGO":
          return aubLogo
        default:
          return logo
      }
}

export const getAdditionalLinks = (envs: any) => {
  const additionalLinks = envs?.additionalLinks 
    ? JSON.parse(envs.additionalLinks) 
    : {};
  const termsLink = additionalLinks.terms ||  AppRoutes.TERMS;
  const privacyLink = additionalLinks.privacy || AppRoutes.PRIVACY;

  return { termsLink, privacyLink };
};